export const environment = {
  production: true,
  servers: {
    back: 'https://api-cancilleriadigital.mppre.gob.ve',
    auth: 'https://api-cancilleriadigital.mppre.gob.ve',
  },
  app: 'Cancillería Digital',
  active: {
    register: true,
    password: true,
    lock: true,
  },
  limitRequestBody: {
    img: 3145728,
    pdf: 5242880,
  }
};
